export default {

    LOAD_FLEET_DEPARTURES(state, fleet_departures) {
        state.items = fleet_departures;
    }

}